import { render, staticRenderFns } from "./SelectBox.vue?vue&type=template&id=b9ae37ea&"
import script from "./SelectBox.vue?vue&type=script&lang=ts&"
export * from "./SelectBox.vue?vue&type=script&lang=ts&"
import style0 from "./SelectBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports